import type { TranslationsFlat } from '@tolgee/web'
import { convertNestedObject } from './converter'

// Converts tolgee's ICU format (only used in development) to i18next format
export const tolgeePreProcessor = (translations: TranslationsFlat) => {
  const translationMap =
    translations instanceof Map ? (Object.fromEntries(translations) as TranslationsFlat) : translations
  return process.env.NODE_ENV === 'development' ? convertNestedObject(translationMap) : translationMap
}
